import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  prices: [[0]],
  subTotal: 0,
  subTotalAmount: 0,
  productSubtotal: [0],
  productSubtotalAmount: 0,
  itemSubtotal: [0],
  total: 0,
  shippingCost: 0,
  discountAmount: 0,
  taxAmount: 0,
  taxRate: 0,
  additionalFeeAmount: 0,
  additionalFeeLabel: 'Additional Fee',
  stripeFee: 0,
  netAmount: 0,
  addonAmounts: [0],
  isCalculatingShipping: false,
  submitDisabled: false,
  selectedPaymentType: null, // For payment-type-based fee calculation
  // Lines /calculate-pricing zeroed because a table code is not in the
  // product's table: [{ reason: 'unknown_table_row', itemIndex, lineIndex, field, code }].
  // Display-only, never saved.
  tableWarnings: [],
};

const pricingSlice = createSlice({
  name: 'pricing',
  initialState,
  reducers: {
    setPricingState: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetPricingState: () => initialState,
  },
});

export const { setPricingState, resetPricingState } = pricingSlice.actions;
export default pricingSlice.reducer;
